<div class="btn-group btn-group-toggle" role="group">
  <ng-container *ngFor="let option of opts()">
    <input type="radio" [id]="name + '.' + option.value" [(ngModel)]="model" [name]="name" [value]="option.value"
      (change)='change($event)'
      class="btn-check" autocomplete="off" [disabled]="disabled">
    <label [for]="name + '.' + option.value" class="btn btn-outline-default" [class.active]='model === option.value'>{{option.label}}</label>
  </ng-container>
</div>